import { CommonModule } from '@angular/common';
// Modules
import { ChartsSharedModule } from '../charts-shared/charts-shared.module';
import { HelpModalModule } from 'NewAngular/features/components/modals/help-modal/help-modal.module';
import { IconModule } from 'NewAngular/features/directives/icon/icon.module';
import { LoadingSymbolModule } from 'NewAngular/features/components/loaders/loading-symbol/loading-symbol.module';
import { TooltipModule } from 'NewAngular/features/directives/popovers/tooltip/tooltip.module';
import * as i0 from "@angular/core";
// This module exports portable scatter plot components,
// meaning they can be used outside of the scatter plot page.
export class ScatterPlotModule {
}
ScatterPlotModule.ɵfac = function ScatterPlotModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || ScatterPlotModule)(); };
ScatterPlotModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: ScatterPlotModule });
ScatterPlotModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule, HelpModalModule, IconModule, LoadingSymbolModule, TooltipModule, ChartsSharedModule] });
